import { useRef } from "react"
import { Link } from "react-router-dom"

import { HelpCenterContent, HelpCenterHeader, WikiSection } from "@/areas/help-center"
import Article from "@/shared/layouts/Article/Article"

function PosConfiguration() {
  const contentRef = useRef<HTMLDivElement>(null)

  return (
    <HelpCenterContent ref={contentRef}>
      <HelpCenterHeader
        title="POS Configuration Guide"
        subtitle="Select your POS system to view the setup guide."
        backPath="/help-center"
        backLabel="Help Center"
        contentRef={contentRef}
      />

      <WikiSection id="available-pos" title="Available POS Systems">
        <Article>
          <p>
            Stream OCB integrates with multiple POS systems. Select your system below
            to view the detailed setup instructions.
          </p>
          <ul>
            <li><Link to="/help-center/pos-configuration/oracle">Oracle Setup</Link></li>
            <li><Link to="/help-center/pos-configuration/clover">Clover Setup</Link></li>
            <li><Link to="/help-center/pos-configuration/focus">Focus Setup</Link></li>
            <li><Link to="/help-center/pos-configuration/table-needs">Table Needs Setup</Link></li>
            <li><Link to="/help-center/pos-configuration/cbs-north-star">CBS North Star Setup</Link></li>
          </ul>
        </Article>
      </WikiSection>
    </HelpCenterContent>
  )
}

export default PosConfiguration
